<mat-card class="mat-elevation-z3">
    <div class="action-container">
        <h2 class="table-title">
            {{
                !selection.selected.length
                    ? 'Users'
                    : selection.selected.length === 1
                    ? '1 User selected'
                    : selection.selected.length + ' Users selected'
            }}
        </h2>

        <div class="search-container" color="primary">
            <app-search-bar #search (searchEvent)="applyFilter($event);" (clearSearchEvent)="clearFilter();"></app-search-bar>
        </div>
        <div class="action-buttons">
            <button
                mat-raised-button
                *ngIf="removeItems"
                color="warn"
                [disabled]="!selection.selected.length"
                (click)="deleteUsers(selection)"
                aria-label="Remove selected users"
                matTooltip="Delete"
            >
                <mat-icon>delete_outline</mat-icon>
                <span>Delete</span>
            </button>
            <button
                mat-raised-button
                *ngIf="!removeItems"
                color="primary"
                (click)="toggleSelectUsers()"
                aria-label="Remove User(s)"
                matTooltip="Remove Users"
            >
                <span>Remove</span>
            </button>
            <button
                mat-raised-button
                *ngIf="removeItems"
                color="primary"
                (click)="cancelEdit()"
                aria-label="Cancel edit"
                matTooltip="Cancel Edit"
            >
                <mat-icon>clear</mat-icon>
                <span>Cancel</span>
            </button>
            <button mat-raised-button color="primary" (click)="addUser()" aria-label="Add New User" matTooltip="Add Users">
                <mat-icon>add</mat-icon>
                <span>Add</span>
            </button>
        </div>
    </div>

    <div class="table-wrapper">
        <table #table mat-table [dataSource]="dataSource" matSort>
            <!-- Select Column -->
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox
                        (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()"
                        [aria-label]="checkboxLabel()"
                    >
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox
                        (click)="$event.stopPropagation()"
                        (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)"
                        [aria-label]="checkboxLabel(row)"
                    >
                    </mat-checkbox>
                </td>
            </ng-container>

            <!-- ID Column -->
            <!-- <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
        <td mat-cell *matCellDef="let user">{{ user.userRoleId }}</td>
      </ng-container> -->

            <!-- Name Column -->
            <ng-container matColumnDef="firstName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
                <td mat-cell *matCellDef="let user">{{ user.firstName }}</td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="lastName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
                <td mat-cell *matCellDef="let user">{{ user.lastName }}</td>
            </ng-container>

            <!-- Username Column -->
            <!-- <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Username</th>
        <td mat-cell *matCellDef="let user">{{ user.username }}</td>
      </ng-container> -->

            <!-- Email Column -->
            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                <td mat-cell *matCellDef="let user">{{ user.email }}</td>
            </ng-container>

            <!-- User Role Column -->
            <ng-container matColumnDef="roleName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Role</th>
                <td mat-cell *matCellDef="let user">{{ user.roleName }}</td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let user" style="text-align: right">
                    <button mat-flat-button color="primary" (click)="editUser(user)">Edit</button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
                mat-row
                *matRowDef="let row; let even = even; columns: displayedColumns"
                (click)="removeItems ? selection.toggle(row) : null"
                [ngClass]="{ evenRow: even, pointer: removeItems, selectedRow: selection.isSelected(row) }"
            ></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="5">
                    No user info matching the filter
                    <span *ngIf="search.value"> "{{ search.value }}"</span>
                </td>
            </tr>
        </table>
    </div>
    <mat-paginator [pageSizeOptions]="[15, 25, 50, 100]"></mat-paginator>
</mat-card>
